<template>
  <div class="use-guide">
    <div class="flex_between mb10">
      <div v-if="!noticeShow">
        <span class="fs16 bold">使用指南</span>
        <a class="active_color ml20" @click="noticeShow = !noticeShow">关闭指南</a>
      </div>
      <a v-if="noticeShow" class="active_color" @click="noticeShow = !noticeShow">查看指南</a>
    </div>
    <div v-if="!noticeShow" class="content c9">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      noticeShow: false
    }
  }
}
</script>

<style lang="scss" scoped>
.use-guide{
  .content{
    line-height: 22px;
  }
}
</style>
